export interface GuestAuthor {
  avatar: string;
  href?: string;
  initials: string;
  name: string;
  role: string;
}

export const JAKUB_ANTALIK: GuestAuthor = {
  avatar:
    "https://ho1jr3x2dcwdu3t5.public.blob.vercel-storage.com/homepage/people/jakub-antalik.avif",
  href: "https://x.com/jakubantalik",
  initials: "JA",
  name: "Jakub Antalik",
  role: "Creator of transitions.dev",
};
